import { createIsomorphicFn, createClientOnlyFn } from '@tanstack/react-start'

export const getLocationHash = createIsomorphicFn()
  .server(() => {
    return ''
  })
  .client(() => {
    return window.location.hash
  })

export const setLocationHash = createClientOnlyFn((hash: string) => {
  window.location.hash = hash
})

export const matchMedia = createClientOnlyFn((query: string) => {
  return window.matchMedia(query).matches
})

export const getSystemTheme = createClientOnlyFn(() => {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light'
})

export const getLocalStorage = createClientOnlyFn((key: string) => {
  return localStorage.getItem(key)
})

export const setLocalStorage = createClientOnlyFn(
  (key: string, value: string) => {
    localStorage.setItem(key, value)
  }
)

export const removeLocalStorage = createClientOnlyFn((key: string) => {
  localStorage.removeItem(key)
})
